import { doMutation } from "../../core-module/util/graphqlHelper";

export const updateQuizContentStatus = ({ id, isActive }) => {
  const mutation = require("../api/mutation/updateQuizContentStatus.gql");
  const variables = { id, isActive };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.updateQuizContentStatus };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
